// extracted by mini-css-extract-plugin
export var selected = "FilterItem-module--selected--TlZUi";